import styled from "styled-components"

export const BackgroundPicture = styled.img`
  width:100% ;
  height:100% ;
  object-fit:cover ;
`